// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";

function PaymentInputField(props) {
  var __autocomplete = props.autocomplete;
  var __isDisabled = props.isDisabled;
  var __className = props.className;
  var __placeholder = props.placeholder;
  var __type_ = props.type_;
  var __name = props.name;
  var __fieldName = props.fieldName;
  var errorString = props.errorString;
  var __rightIcon = props.rightIcon;
  var onBlur = props.onBlur;
  var value = props.value;
  var __inputFieldClassName = props.inputFieldClassName;
  var __fieldWidth = props.fieldWidth;
  var __height = props.height;
  var setIsValid = props.setIsValid;
  var __isValid = props.isValid;
  var isValid = __isValid !== undefined ? Caml_option.valFromOption(__isValid) : true;
  var height = __height !== undefined ? __height : "";
  var fieldWidth = __fieldWidth !== undefined ? __fieldWidth : "100%";
  var inputFieldClassName = __inputFieldClassName !== undefined ? __inputFieldClassName : "";
  var rightIcon = __rightIcon !== undefined ? Caml_option.valFromOption(__rightIcon) : null;
  var fieldName = __fieldName !== undefined ? __fieldName : "";
  var name = __name !== undefined ? __name : "";
  var type_ = __type_ !== undefined ? __type_ : "text";
  var placeholder = __placeholder !== undefined ? __placeholder : "";
  var className = __className !== undefined ? __className : "";
  var isDisabled = __isDisabled !== undefined ? __isDisabled : false;
  var autocomplete = __autocomplete !== undefined ? __autocomplete : "on";
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var config = match.config;
  var match$1 = config.appearance;
  var innerLayout = match$1.innerLayout;
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match$3 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var parentURL = match$3.parentURL;
  var contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  var paymentType = Core__Option.getOr(props.paymentType, contextPaymentType);
  var match$4 = React.useState(function () {
        return false;
      });
  var setInputFocused = match$4[1];
  var inputFocused = match$4[0];
  var handleFocus = function (param) {
    setInputFocused(function (param) {
          return true;
        });
    if (setIsValid !== undefined) {
      setIsValid(function (param) {
            
          });
    }
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(parentURL);
  };
  var handleBlur = function (ev) {
    setInputFocused(function (param) {
          return false;
        });
    if (onBlur !== undefined) {
      onBlur(ev);
    }
    Utils$OrcaPaymentPage.handleOnBlurPostMessage(parentURL);
  };
  var backgroundClass;
  switch (paymentType) {
    case "Payment" :
    case "PaymentMethodsManagement" :
        backgroundClass = themeObj.colorBackground;
        break;
    default:
      backgroundClass = "transparent";
  }
  var direction = type_ === "password" || type_ === "tel" ? "ltr" : "";
  var focusClass = inputFocused || value.length > 0 ? "mb-7 pb-1 pt-2 " + themeObj.fontSizeXs + " transition-all ease-in duration-75" : "transition-all ease-in duration-75";
  var floatinglabelClass = inputFocused ? "Label--floating" : "Label--resting";
  var getClassName = function (initialLabel) {
    if (value.length === 0) {
      return initialLabel + "--empty";
    } else if (isValid !== undefined) {
      if (isValid) {
        return initialLabel + "--valid";
      } else {
        return initialLabel + "--invalid";
      }
    } else {
      return "";
    }
  };
  var labelClass = getClassName("Label");
  var inputClass = getClassName("Input");
  var inputLogoClass = getClassName("InputLogo");
  var inputClassStyles = innerLayout === "Spaced" ? "Input" : "Input-Compressed";
  return React.createElement("div", {
              className: "flex flex-col w-full",
              style: {
                color: themeObj.colorText
              }
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: fieldName.length > 0 && config.appearance.labels === "Above" && innerLayout === "Spaced",
                  children: React.createElement("div", {
                        "aria-hidden": true,
                        className: "Label " + labelClass,
                        style: {
                          fontSize: themeObj.fontSizeLg,
                          fontWeight: themeObj.fontWeightNormal,
                          marginBottom: "5px",
                          opacity: "0.6"
                        }
                      }, fieldName)
                }), React.createElement("div", {
                  className: "flex flex-row ",
                  style: {
                    direction: direction
                  }
                }, React.createElement("div", {
                      className: "relative w-full " + inputFieldClassName
                    }, React.createElement("input", {
                          ref: Caml_option.some(props.inputRef),
                          "aria-label": "Type to fill " + (
                            fieldName.length > 0 ? fieldName : name
                          ) + " input",
                          className: inputClassStyles + " " + inputClass + " " + className + " focus:outline-none transition-shadow ease-out duration-200",
                          "data-testid": name,
                          style: {
                            background: isDisabled ? themeObj.disabledFieldColor : backgroundClass,
                            height: height,
                            padding: themeObj.spacingUnit,
                            width: fieldWidth
                          },
                          autoComplete: autocomplete,
                          disabled: isDisabled || match$2.readOnly,
                          maxLength: props.maxLength,
                          name: name,
                          pattern: props.pattern,
                          placeholder: config.appearance.labels === "Above" ? placeholder : "",
                          type: type_,
                          value: value,
                          onFocus: handleFocus,
                          onBlur: handleBlur,
                          onChange: props.onChange
                        }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                          condition: config.appearance.labels === "Floating",
                          children: React.createElement("div", {
                                "aria-hidden": true,
                                className: "Label " + floatinglabelClass + " " + labelClass + " absolute bottom-0 ml-3 " + focusClass + " pointer-events-none",
                                style: {
                                  fontSize: inputFocused || value.length > 0 ? themeObj.fontSizeXs : "",
                                  marginBottom: inputFocused || value.length > 0 ? "" : themeObj.spacingUnit,
                                  opacity: "0.6"
                                }
                              }, fieldName)
                        })), React.createElement("div", {
                      className: "InputLogo " + inputLogoClass + " relative flex -ml-10 items-center"
                    }, rightIcon)), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: innerLayout === "Spaced",
                  children: errorString !== undefined ? React.createElement(RenderIf$OrcaPaymentPage.make, {
                          condition: errorString.length > 0,
                          children: React.createElement("div", {
                                className: "Error pt-1",
                                style: {
                                  color: themeObj.colorDangerText,
                                  fontSize: themeObj.fontSizeSm,
                                  textAlign: "left",
                                  alignSelf: "start"
                                }
                              }, errorString)
                        }) : null
                }));
}

var make = PaymentInputField;

export {
  make ,
}
/* react Not a pure module */
